
import { useStatus } from '@platyplus/vue-hasura-backend-plus'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Topbar',
  emits: ['menu-toggle'],
  setup(_, { emit }) {
    const onMenuToggle = (event: Event) => {
      emit('menu-toggle', event)
    }
    const connected = useStatus()
    return { onMenuToggle, connected }
  }
})
